import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TemplateFolder } from '../component/pages/generator/email.store';

@Injectable({
    providedIn: 'root'
})
export class TemplateFolderService {
    private apiUrl = `${environment.backendUrl}/api/template_folders/`;

    constructor(private http: HttpClient) { }

    getFolders(type?: string): Observable<TemplateFolder[]> {
        let params = new HttpParams();
        if (type) {
            params = params.set('type', type);
        }
        return this.http.get<TemplateFolder[]>(this.apiUrl, { params });
    }

    createFolder(name: string, parentId?: number | null): Observable<TemplateFolder> {
        const payload: any = { name };
        if (parentId) {
            payload.parent = parentId;
        }
        return this.http.post<TemplateFolder>(this.apiUrl, payload);
    }

    updateFolder(id: number, name: string): Observable<TemplateFolder> {
        return this.http.patch<TemplateFolder>(`${this.apiUrl}${id}/`, { name });
    }

    deleteFolder(id: number): Observable<void> {
        return this.http.delete<void>(`${this.apiUrl}${id}/`);
    }
}
